module.exports = "https://static.energy5.com/_next/static/images/evChargingBgMob-49bda7e794106a5baa561ad1a331c9ab.webp";